module.exports = __webpack_public_path__ + "static/media/bootstrap.76d7c6aa.svg";